module.exports = __webpack_public_path__ + "img/zsb.6ee66af6.png";